import { render } from "./StaffTree.vue?vue&type=template&id=45d8b4f7"
import script from "./StaffTree.vue?vue&type=script&lang=js"
export * from "./StaffTree.vue?vue&type=script&lang=js"
script.render = render

export default script